// Catálogo de códigos de error RFC 7807 — fuente: docs/04-api.md §1.
export const ERROR_CODES = [
  "invalid_credentials",
  "mfa_required",
  "account_locked",
  "domain_suspended",
  "registration_disabled",
  "audit_ingest_disabled",
  "token_expired",
  "token_revoked",
  "token_reused",
  "insufficient_scope",
  "quota_exceeded",
  "node_unavailable",
  "validation_error",
  "rate_limited",
  "not_found",
  "conflict",
  "unauthorized",
  "forbidden",
  "internal_error",
] as const

export type ErrorCode = (typeof ERROR_CODES)[number]

export interface FieldError {
  field: string
  code: string
  message: string
}

export interface ProblemDetails {
  type: string
  title: string
  status: number
  detail?: string
  code: ErrorCode
  trace_id?: string
  errors?: FieldError[]
}
